import { FC, useState } from 'react';
import { Container, Image, ImageContainer, TitleContainer } from './DealerCard.styles';
import { TConcessionaria, TGrupoConcessionaria } from '../../services';
import { getImageUrl } from '../../utils';

interface DealerCardProps {
	dealerData: TConcessionaria;
}

const DealerCard: FC<DealerCardProps> = ({ dealerData }) => {

	const [src, setSrc] = useState(getImageUrl.concessionaria(dealerData));

	const fallbackSrc = getImageUrl.grupoConcessionaria({
		id: dealerData?.id,
		logotipo: dealerData?.logotipo,
	} as TGrupoConcessionaria);

	return (
		<Container>
			<TitleContainer>
			    {dealerData?.fantasia || dealerData.razaoSocial || '' }
			</TitleContainer>
			<ImageContainer>
			<Image
			src={src}
			alt="imagem concessionária"
			width={120}
			height={60}
			onError={() => setSrc(fallbackSrc)}
			/>
			</ImageContainer>
		</Container>
	);
};

export default DealerCard;
